import { Tooltip as MantineTooltip, TooltipProps } from '@mantine/core';

export type ITooltipProps = TooltipProps;

/** @registry Design-layer pass-through over Mantine Tooltip; import this instead of @mantine/core Tooltip outside src/design. Compound statics (Tooltip.Floating, Tooltip.Group) are preserved. */
export const Tooltip = MantineTooltip;
